import React from "react";
import * as styles from "./velavu-scrollable-round-table.module.scss";
import * as tableStyles from "../styles/table.module.scss";
import { WeightedTable, WeightedTableColumnLayout } from "./weighted-table";
import { classArr } from "../helper/style-helper";

export interface VelavuScrollableRoundTableProps {
	style?: React.CSSProperties;
	className?: string;
	children?: React.ReactNode;
	layout?: readonly WeightedTableColumnLayout[];
}

export function VelavuScrollableRoundTable(
	props: VelavuScrollableRoundTableProps,
) {
	return (
		<div
			style={props.style}
			className={classArr(
				props.className,
				styles.wrapper,
				tableStyles.roundTable,
			)}
		>
			<WeightedTable layout={props.layout}>
				{props.children}
			</WeightedTable>
		</div>
	);
}
